/* eslint-disable no-console */
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import styled from 'styled-components';

import { Button, Icon, Text } from 'core/ui/atoms';

const WeekSlider = ({ defaultWeek, deliveryPeriods, selectedWeek, onChangeWeek }) => {
  const nextPeriod = selectedWeek !== -1 && selectedWeek < deliveryPeriods.length - 1
    ? deliveryPeriods[selectedWeek + 1] : null;
  const previousPeriod = selectedWeek > 0 ? deliveryPeriods[selectedWeek - 1] : null;

  const renderWeeks = () => {
    const weekData = deliveryPeriods[selectedWeek] || defaultWeek;
    return (
      <CurrentWeek>
        Week of
        <WeekData>{moment(weekData.date).format('MMMM Do')}</WeekData>
      </CurrentWeek>
    );
  };

  return (
    <WeekSlide>
      <CaretButton btn-outline onClick={() => previousPeriod?.id && onChangeWeek(previousPeriod?.id)}>
        <Caret icon='arrow_l' />
      </CaretButton>
      {renderWeeks()}
      <CaretButton btn-outline onClick={() => nextPeriod?.id && onChangeWeek(nextPeriod?.id)}>
        <Caret icon='arrow_r' />
      </CaretButton>
    </WeekSlide>
  );
};

WeekSlider.propTypes = {
  defaultWeek: PropTypes.object.isRequired,
  deliveryPeriods: PropTypes.array,
  selectedWeek: PropTypes.number,
  onChangeWeek: PropTypes.func,
};

const CaretButton = styled(Button)`
  color: ${({ theme }) => theme.colors.creamWhite};
`;

const WeekData = styled(Text)`
  color: ${(p) => p.theme.colors.creamWhite};
  font-family: ${({ theme }) => theme.typography.familyLarken};
  font-size: 16px;
  font-style: italic;
  font-weight: 800;
  line-height: 32px;
  letter-spacing: 0.48px;
`;

const WeekSlide = styled.div`
  text-align: center;
  ${(p) => p.theme.max('sm')`
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 48px;
    font-family: ${({ theme }) => theme.typography.familyPopins};
    font-weight: 500;
    font-size: 16px;
    background: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.creamWhite};
  `}
`;

const CurrentWeek = styled.p`
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 6px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.creamWhite};
`;

const Caret = styled(Icon)`
  display: inline-block;
  transition: transform 0.25s ease-in-out;
  transform-style: preserve-3d;
  transform: rotateX(${(p) => p.$open ? '180deg' : '0deg' });
`;

export default WeekSlider;
